// Primary (Years 1-6) workbooks use Warm-up / Teach / Practise / Check and close; secondary use Starter / Main / Plenary.
const PRACTISE_KEY = /^practise/i;

export const practiseText = (lesson) => {
  const key = Object.keys(lesson.extra || {}).find((k) => PRACTISE_KEY.test(k));
  return key ? lesson.extra[key] : null;
};

export const strategiesExtra = (lesson, isPrimary) =>
  Object.fromEntries(Object.entries(lesson.extra || {}).filter(([k]) => !(isPrimary && PRACTISE_KEY.test(k))));

export const lessonParts = (lesson, isPrimary) => isPrimary ? [
  { key: 'objective', label: 'Learning focus', value: lesson.objective },
  { key: 'starter', label: 'Warm-up (5–10 min)', value: lesson.starter },
  { key: 'main', label: 'Teach (10 min)', value: lesson.main_activity },
  { key: 'practise', label: 'Practise (15–20 min)', value: practiseText(lesson) },
  { key: 'plenary', label: 'Check and close (5 min)', value: lesson.plenary },
  { key: 'resources', label: 'Resources', value: lesson.resources },
] : [
  { key: 'objective', label: 'Learning objective', value: lesson.objective },
  { key: 'starter', label: 'Starter (5 min)', value: lesson.starter },
  { key: 'main', label: 'Main activity (30–40 min)', value: lesson.main_activity },
  { key: 'plenary', label: 'Plenary (5 min)', value: lesson.plenary },
  { key: 'homework', label: 'Homework', value: lesson.homework },
  { key: 'resources', label: 'Resources', value: lesson.resources },
];
